'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('../../button');

var _button2 = _interopRequireDefault(_button);

var _styledText = require('../../styled-text');

var _styledText2 = _interopRequireDefault(_styledText);

var _modalContext = require('../../../context/modal-context');

require('./unsaved-changes.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var STYLE_BASE = 'zk-modal-overlay_unsaved-changes-modal_';

var UnsavedChangesModal = function (_Component) {
  _inherits(UnsavedChangesModal, _Component);

  function UnsavedChangesModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnsavedChangesModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnsavedChangesModal.__proto__ || Object.getPrototypeOf(UnsavedChangesModal)).call.apply(_ref, [this].concat(args))), _this), _this.cancelButton = _react2.default.createRef(), _this.discardButton = _react2.default.createRef(), _this.handleKeyDown = function (e) {
      e.stopPropagation();

      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === _this.cancelButton.current) {
            e.preventDefault();

            _this.discardButton.current.focus();
          } // TAB

        } else if (document.activeElement === _this.discardButton.current) {
          e.preventDefault();

          _this.cancelButton.current.focus();
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnsavedChangesModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        priorFocusedElement: document.activeElement
      }, function () {
        _this2.discardButton.current.focus();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(_modalContext.ModalConsumer, null, function (_ref2) {
        var hideUnsavedModal = _ref2.hideUnsavedModal,
            hide = _ref2.hide;
        return _react2.default.createElement('div', {
          className: STYLE_BASE + 'background',
          tabIndex: '0',
          onKeyDown: _this3.handleKeyDown
        }, _react2.default.createElement('div', {
          className: STYLE_BASE + 'container'
        }, _react2.default.createElement(_styledText2.default, {
          className: STYLE_BASE + 'title'
        }, 'You have unsaved changes. Would you like to discard these changes?'), _react2.default.createElement('div', {
          className: STYLE_BASE + 'buttonContainer'
        }, _react2.default.createElement(_button2.default, {
          className: STYLE_BASE + 'modalButtonWrapper',
          onClick: function onClick() {
            hideUnsavedModal();

            _this3.state.priorFocusedElement.focus();
          },
          secondary: true,
          ref: _this3.cancelButton,
          testid: 'UNSAVED_CANCEL_DELETE',
          title: 'Cancel'
        }), _react2.default.createElement(_button2.default, {
          onClick: hide,
          ref: _this3.discardButton,
          testid: 'UNSAVED_SUBMIT_DELETE_',
          title: 'Discard'
        }))));
      });
    }
  }]);

  return UnsavedChangesModal;
}(_react.Component);

exports.default = UnsavedChangesModal;